import { React, useEffect } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import Spinner from '../../../../components/spinner/Spinner';
import DecodeProbeDetailsContent from './DecodeProbeDetailsContent';
import './DecodeProbeDetails.scss';

const DecodeProbeDetails = ({ isFormFetching, fetchFormData, content, result }) => {
    useEffect(() => {
        if (!isFormFetching && isEmpty(content)) {
            fetchFormData();
        }
    });

    return isEmpty(content) || isEmpty(result) ? (
        <Spinner />
    ) : (
        <div className="container decode-section">
            <DecodeProbeDetailsContent result={result} content={content[0]} />
        </div>
    );
};

DecodeProbeDetails.defaultProps = {
    result: {},
    content: [],
    isFormFetching: false,
    fetchFormData: () => {},
};

DecodeProbeDetails.propTypes = {
    result: PropTypes.object,
    content: PropTypes.array,
    isFormFetching: PropTypes.bool,
    fetchFormData: PropTypes.func,
};

export default DecodeProbeDetails;
